import { CURVE, Highline } from "./highline.js";
export { Highline, CURVE };
export var HighlineService = new Highline();
